import PlainShell from '../../../layouts/PlainShell.vue';
import AnonymousSurvey from '../views/AnonymousSurvey.vue';

export default [{
    path: '/',
    name: 'plainModule',
    component: PlainShell,
    children: [{
      path: '/jobseeker/anonymous-survey/',
      name: 'anonsurvey',
      component: AnonymousSurvey,
      title: 'Anonymous Survey'
      },
    ]
  }];